export const colores = {
    primario: '#2a358b',
}